module.exports = __webpack_public_path__ + "img/meigui.aa00c610.gif";